import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatTransferInfo($chatId: ID!) {
    chat(id: $chatId) {
      id
      transfer {
        id
        confirmedAt
      }
    }
  }
`);
